@if (formStatus === 'error') {
    <button class="button is-danger  is-cursor">
        <fa-icon [icon]="faExclamationTriangle"></fa-icon>
    </button>
}


@if (formStatus === 'success') {
    <button class="button is-success is-cursor">
        <fa-icon [icon]="faCheck"></fa-icon>
    </button>
}

@if (formStatus === 'loading') {
    <button class="button is-loading is-cursor" [ngClass]="classes">&nbsp;
        {{ loadingMessage }}
    </button>
}

@if (!formStatus || formStatus == 'submitForm') {
    <button (debounceClick)="_submit()"  [ngClass]="classes"
            class="button"
            lib-debounce-click>
        {{ submitLabel }}
    </button>
}

@if (formStatus === 'readOnly') {
    <div class="button is-warning read-only is-cursor">
        {{ readOnlyText }}
    </div>
}
